import { Button, Chip, Stack } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { useInvestorScope } from '../../store/selectors';
import { useToast } from '../../ui/feedback';
import { EntityFilter, InvestorTitle } from '../common';
import TransactionList from './TransactionList';

const TYPE_FILTERS = [
  { key: 'ALL', label: 'All', types: [] as string[] },
  { key: 'INCOME', label: 'Income', types: ['DISTRIBUTION', 'DRP_ISSUE', 'WITHHOLDING'] },
  {
    key: 'INVEST',
    label: 'Investments',
    types: ['ISSUE', 'CALL_PAYMENT', 'MIGRATION_OPENING', 'TRANSFER_IN'],
  },
  {
    key: 'OUT',
    label: 'Redemptions & transfers',
    types: ['REDEMPTION', 'CAPITAL_RETURN', 'TRANSFER_OUT'],
  },
];

export default function TransactionsPage() {
  const scope = useInvestorScope();
  const toast = useToast();
  const [entity, setEntity] = useState('ALL');
  const [type, setType] = useState('ALL');
  const entries = useMemo(() => {
    const filter = TYPE_FILTERS.find((item) => item.key === type)!;
    return scope.ledger.filter(
      (entry) =>
        (entity === 'ALL' || entry.holderId === entity) &&
        (filter.types.length === 0 || filter.types.includes(entry.type)),
    );
  }, [scope.ledger, entity, type]);
  return (
    <>
      <InvestorTitle
        title="Activity"
        subtitle="Every transaction on the register for your entities."
        action={
          <Button variant="outlined" onClick={() => toast('Transactions exported to CSV', 'info')}>
            Export CSV
          </Button>
        }
      />
      <EntityFilter holders={scope.holders} value={entity} onChange={setEntity} />
      <Stack useFlexGap direction="row" spacing={1} sx={{ mb: 2, flexWrap: 'wrap', rowGap: 1 }}>
        {TYPE_FILTERS.map((item) => (
          <Chip
            key={item.key}
            label={item.label}
            size="small"
            color={type === item.key ? 'secondary' : 'default'}
            variant={type === item.key ? 'filled' : 'outlined'}
            onClick={() => setType(item.key)}
          />
        ))}
      </Stack>
      <TransactionList entries={entries} showEntity />
    </>
  );
}
